import { environment } from "../environment";
import { ClubUser } from "../models/clubUser";
import api from "./api";

export async function getAllUserClubs(userId, role = ''): Promise<ClubUser[]> {
  const url = environment.api.user.getClubs
    .replace('{userId}', String(userId))
    .replace('{role}', String(role || ''))

  const data: ClubUser[] = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => []);

  return data;
}

export async function getClubUser(userId: number, clubId: number): Promise<ClubUser | undefined> {
  const url = environment.api.user.getClubUser
    .replace('{userId}', String(userId))
    .replace('{clubId}', String(clubId));

  const data: ClubUser = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => undefined);

  return data;
}